import React from "react";
import { useNavigate } from "react-router-dom";
import { getImage } from "../../../utils/cloudinarySizing";

const LeadCard = ({
    lead,
    job,
    activeDropupId,
    setActiveDropupId,
    dropupForm,
    setDropupForm,
    handleLeadAction,
    handleDropupConfirm,
}) => {

    console.log(lead)

    const handleProfileClick = () => {
        const profile = lead.profile;

        if (!profile?.id) return;

        if (profile.role === "business") {
            navigate(`/business/${profile.id}`);
        } else if (profile.role === "freelancer") {
            navigate(`/freelancer/${profile.id}`);
        }
    };

    const navigate = useNavigate();

    return (
        <div className="lead-card">

            {/* TOP INFO */}
            <div className="lead-info">

                <div className="thumbnail-wrapper">
                    <img
                        src={
                            getImage(
                                lead.profile?.profile?.photo_original,
                                "avatar_sm"
                            ) || "/default-avatar.png"
                        }
                        className="job-thumbnail"
                        alt="lead"
                        style={{ cursor: "pointer" }}
                        onClick={handleProfileClick}
                    />
                </div>

                <div className="lead-details">

                    {/* NAME / IDENTIFIER */}
                    <p>
                        <strong>
                            {lead.profile?.role === "business"
                                ? (lead.profile?.business_name ||
                                    lead.profile?.username ||
                                    "Business")
                                : (
                                    lead.profile?.first_name ||
                                        lead.profile?.last_name
                                        ? `${lead.profile?.first_name || ""} ${lead.profile?.last_name || ""}`.trim()
                                        : lead.profile?.username || "Unknown User"
                                )
                            }
                        </strong>
                    </p>

                    {/* PROFESSION (optional for both, but mostly freelancer) */}
                    <p>
                        {lead.profile?.profession?.name || "No profession"}
                    </p>

                    {/* CONTACT INFO */}
                    <p style={{ fontSize: "13px" }}>
                        {lead.profile?.email || "No email"}
                    </p>

                    <p style={{ fontSize: "13px" }}>
                        {lead.profile?.profile?.phone_number || "No phone"}
                    </p>

                    {/* STATUS */}
                    <p>
                        Status:{" "}
                        <span
                            style={{
                                color:
                                    lead.status === "accepted"
                                        ? "#4CAF50"
                                        : lead.status === "pending"
                                            ? "#ff9800"
                                            : "#f44336",
                            }}
                        >
                            {lead.status}
                        </span>
                    </p>

                    {/* DATE */}
                    <p style={{ fontSize: "12px", opacity: 0.7 }}>
                        {new Date(lead.created_at).toLocaleDateString()}
                    </p>

                </div>
            </div>

            {/* ACTIONS */}
            <div className="lead-actions">

                {/* ACCEPT */}
                {lead.status === "pending" && (
                    <button
                        className="card-button accept-btn"
                        onClick={() => {
                            setDropupForm({
                                email: job.profile?.email || "",
                                phone: job.profile?.phone_number || ""
                            });

                            setActiveDropupId(lead.id);
                        }}
                    >
                        Accept
                    </button>
                )}

                {/* REJECT */}
                {lead.status === "pending" && (
                    <button
                        className="card-button reject-btn"
                        onClick={() => handleLeadAction(lead.id, "rejected")}
                    >
                        Reject
                    </button>
                )}


                {/* DROPUP */}
                {activeDropupId === lead.id && (
                    <div className="lead-dropup-card">

                        <h4>Send Info</h4>

                        <div className="dropup-card-content">

                            <div className="dropup-profile-info">
                                <img
                                    className="dropup-photo"
                                    src={getImage(job.profile?.photo_original, "avatar_sm") || "/default-avatar.png"}
                                    alt="profile"
                                />

                                <p>{job.profile?.first_name || "Unknown"}</p>
                            </div>

                            <div className="dropup-inputs">

                                <label>Email</label>
                                <input
                                    className="dropup-input"
                                    value={dropupForm.email}
                                    onChange={(e) =>
                                        setDropupForm({
                                            ...dropupForm,
                                            email: e.target.value,
                                        })
                                    }
                                />

                                <label>Phone</label>
                                <input
                                    className="dropup-input"
                                    value={dropupForm.phone}
                                    onChange={(e) =>
                                        setDropupForm({
                                            ...dropupForm,
                                            phone: e.target.value,
                                        })
                                    }
                                />

                            </div>
                        </div>

                        <div className="dropup-buttons">

                            <button
                                className="confirm-btn"
                                onClick={() => {
                                    handleLeadAction(lead.id, "accepted", dropupForm);
                                    setActiveDropupId(null);
                                }}
                            >
                                Confirm
                            </button>

                            <button
                                className="cancel-btn"
                                onClick={() => setActiveDropupId(null)}
                            >
                                Cancel
                            </button>

                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LeadCard;